export const HEADER_HEIGHT = 56;
export const SLUG_BAR_HEIGHT = 40;
export const SCROLL_DIRECTION_THRESHOLD = 20;
export const SLUG_BAR_LOCK_PERIOD = 1500;
export const PRODUCTS_ON_INITIAL_LOAD = 6;
export const PRODUCTS_ON_LOAD_MORE = 10;
